function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import Popover from '@material-ui/core/Popover';
import renderIf from '@signal/utils/renderIf';
import componentPropType from '@signal/prop-types/component';
import { optionsPropType } from './propTypes';
import { Wrapper, DefaultButton, List, ListPaper, ListItemDivider, ListItem, ListItemContent } from './styles';
export var MENU_WIDTH_STATIC = 'static';
export var MENU_WIDTH_DYNAMIC = 'dynamic';

var AddSegmentButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(AddSegmentButton, _PureComponent);

  var _super = _createSuper(AddSegmentButton);

  function AddSegmentButton(props) {
    var _this;

    _classCallCheck(this, AddSegmentButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      anchorEl: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var onClick = _this.props.onClick;

      _this.setState({
        anchorEl: event.currentTarget,
        menuWidth: _this.getMenuWidth()
      });

      onClick(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (e) {
      var onClose = _this.props.onClose;

      _this.setState({
        anchorEl: null
      });

      onClose(e);
    });

    _defineProperty(_assertThisInitialized(_this), "createOptionClickHandler", function (option) {
      return function (e) {
        var onClick = option.onClick;
        var onOptionClick = _this.props.onOptionClick;
        if (onOptionClick) onOptionClick(option);
        if (onClick) onClick(e);

        _this.handleClose();
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionKey", function (option) {
      var keyBy = _this.props.keyBy;
      return isString(option) ? option : option[keyBy];
    });

    _defineProperty(_assertThisInitialized(_this), "renderOption", function (option, i) {
      var _this$props = _this.props,
          isOptionDisabled = _this$props.isOptionDisabled,
          labelBy = _this$props.labelBy,
          renderOption = _this$props.renderOption;

      var key = _this.getOptionKey(option);

      var Option = null;

      if (isFunction(renderOption)) {
        Option = renderOption(option);
      } else {
        var Component = option.component,
            _option$componentProp = option.componentProps,
            componentProps = _option$componentProp === void 0 ? {} : _option$componentProp;
        var content = isString(option) ? option : option[labelBy];
        Option = /*#__PURE__*/React.createElement(ListItem, Object.assign({
          button: true,
          component: Component,
          disabled: isOptionDisabled(option),
          key: key,
          onClick: _this.createOptionClickHandler(option)
        }, componentProps), /*#__PURE__*/React.createElement(ListItemContent, null, content));
      }

      return i > 0 ? [/*#__PURE__*/React.createElement(ListItemDivider, {
        key: "".concat(key, "-divider")
      }), Option] : Option;
    });

    _this.buttonRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(AddSegmentButton, [{
    key: "getMenuWidth",
    value:
    /**
     * This function returns the desired width of the menu.
     *
     * It's somewhat complex, but intentionally so to be flexible.
     */
    function getMenuWidth() {
      var _this$props2 = this.props,
          overallWidth = _this$props2.width,
          width = _this$props2.menuProps.width;

      switch (width) {
        case MENU_WIDTH_DYNAMIC:
          // If `this.props.width` is defined, then use that width for the menu
          // otherwise use JS to get the button width and use that for the menu width.
          width = overallWidth || this.buttonRef.current.getBoundingClientRect().width;
          break;

        case MENU_WIDTH_STATIC:
          // If `this.props.menuProps.width` is set to 'static' then do not explicitly set a menu
          // width and allow the content of the menu to determine the width.
          width = null;
          break;

        default:
          // Based on the prop types, if we get to this default case then this.props.menuWidth.props
          // is expected to be a string or a number that will be directly passed to the style
          // object for the menu thereby explicitly setting the width to that string or number.
          break;
      }

      return width;
    }
  }, {
    key: "buttonProps",
    get: function get() {
      var buttonProps = this.props.buttonProps;
      var defaultProps = {
        variant: 'contained',
        color: 'primary'
      };
      return _objectSpread(_objectSpread({}, defaultProps), buttonProps);
    }
  }, {
    key: "popoverProps",
    get: function get() {
      var popoverProps = this.props.popoverProps;
      var defaultProps = {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        }
      };
      return _objectSpread(_objectSpread({}, defaultProps), popoverProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          anchorEl = _this$state.anchorEl,
          menuWidth = _this$state.menuWidth;
      var _this$props3 = this.props,
          width = _this$props3.width,
          options = _this$props3.options,
          emptyLabel = _this$props3.emptyLabel,
          children = _this$props3.children,
          disabled = _this$props3.disabled,
          name = _this$props3.name,
          className = _this$props3.className,
          Button = _this$props3.buttonComponent;
      return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Button, Object.assign({
        "aria-owns": anchorEl ? name : undefined,
        "aria-haspopup": "true",
        onClick: this.handleClick,
        disabled: disabled,
        buttonRef: this.buttonRef,
        style: {
          width: width
        },
        className: className
      }, this.buttonProps), children), /*#__PURE__*/React.createElement(Popover, Object.assign({
        id: "name",
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: this.handleClose,
        elevation: 0,
        PaperProps: {
          component: ListPaper,
          style: {
            width: menuWidth
          }
        }
      }, this.popoverProps), /*#__PURE__*/React.createElement(List, null, renderIf(options.length > 0, options.map(this.renderOption), /*#__PURE__*/React.createElement(ListItem, {
        disabled: true
      }, /*#__PURE__*/React.createElement(ListItemContent, null, emptyLabel))))));
    }
  }]);

  return AddSegmentButton;
}(PureComponent);

_defineProperty(AddSegmentButton, "propTypes", {
  /**
   * A boolean that is passed to the button component to disable it.
   */
  disabled: PropTypes.bool,

  /**
   * Options - an array of strings or objects that are mapped to the menu
   * options.
   */
  options: optionsPropType,

  /**
   * The callback for when an option is clicked.
   */
  onOptionClick: PropTypes.func,

  /**
   * A function that receives an option as a param and should return true or false
   * denoting whether the option is disabled or not.
   */
  isOptionDisabled: PropTypes.func,

  /**
   * The `keyBy` prop is a string that is used to extract the key from an option
   * if the option is an object. Defaults to "key"
   */
  keyBy: PropTypes.string,

  /**
   * The `labelBy` prop is a string that is used to extract the label from an option
   * if the option is an object. Defaults to "label"
   */
  labelBy: PropTypes.string,

  /**
   * The string that will be displayed as a disabled list item in the menu
   * if not options are available.
   */
  emptyLabel: PropTypes.string,

  /**
   * An accessibility prop that ties the button to it's dropdown menu.
   */
  name: PropTypes.string.isRequired,

  /**
   * The props to be spread to the button component.
   */
  buttonProps: PropTypes.object.isRequired,

  /**
   * Props to be supplied to the popover that are shallow merged
   * with some sensible defaults.
   */
  popoverProps: PropTypes.object,

  /**
   * A component that is passed to the MUI button component.
   */
  buttonComponent: componentPropType,

  /**
   * A function that will be called to render the option with complete control.
   * This function must provide the key for the returned option.
   */
  renderOption: PropTypes.func,

  /**
   * The explicit width to set the button to. If the menuProps.width prop is
   * set to `dynamic` (the default option) this will also be used as the menu's
   * width.
   *
   * Note:
   * Setting the width explicitly will result in slight performance gains if the
   * menuProps.width is also `dynamic` because then the DOM will not be accessed
   * to determine the width of the button and this width will also be used as the menu's width
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * The props to define the menu.
   */
  menuProps: PropTypes.shape({
    /**
     * There are four options here:
     * 1) If the width is set to `static` then the menu's width is determined
     * by the content of the menu.
     * 2) If the width is set to `dynamic` then JS will be used to access the width
     * of the button and set the width of the menu to the same.
     * 3) A number will be used as the pixel width statically.
     * 4) Any other string will be expected to be a CSS appropriate width definition.
     *
     * Defaults to option 2 (dynamic width)
     */
    width: PropTypes.oneOfType([PropTypes.oneOf(['static', 'dynamic']), PropTypes.string, PropTypes.number])
  })
});

_defineProperty(AddSegmentButton, "defaultProps", {
  disabled: false,
  options: [],
  keyBy: 'key',
  labelBy: 'label',
  emptyLabel: 'No Options.',
  isOptionDisabled: function isOptionDisabled() {
    return false;
  },
  buttonProps: {},
  menuProps: {
    width: MENU_WIDTH_DYNAMIC
  },
  buttonComponent: DefaultButton,
  onClick: function onClick() {
    return null;
  },
  onClose: function onClose() {
    return null;
  }
});

export { AddSegmentButton as default };